import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getUserApps: async (userId) => {

      const options = createRequestOptions({ userId });
      
      const result = await fetch(Config.serverUrl + "/GetUserApps", options);
      const response = await result.json();

      return get(response, "response");
    },
    createNewApp: async (userId, templateId, appInfo, buildName) => {
      const options = createRequestOptions({
        userId,
        templateId,
        appInfo,
        buildName,
      });

      const result = await fetch(Config.serverUrl + "/CreateNewApp", options);
      const response = await result.json();

      return get(response, "response");
    },
    getAppInfo: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(Config.serverUrl + "/GetAppInfo", options);
      const response = await result.json();

      return get(response, "response");
    },
    updateAppInfo: async (userId, appId, appInfo) => {
      const options = createRequestOptions({ userId, appId, appInfo });

      const result = await fetch(Config.serverUrl + "/UpdateAppInfo", options);
      const response = await result.json();

      return get(response, "response");
    },
    getAppTemplate: async (userId, appId, templateId) => {
      const options = createRequestOptions({ userId, appId, templateId });

      const result = await fetch(
        Config.mobileServerUrl + "/GetAppTemplate",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    updateAppTemplate: async (userId, appId, appTemplate) => {
      const options = createRequestOptions({ userId, appId, appTemplate });

      const result = await fetch(
        Config.mobileServerUrl + "/UpdateAppTemplate",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    startTestingApp: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(
        Config.serverUrl + "/StartTestingApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getInvitedUsers: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(
        Config.serverUrl + "/GetInvitedUsers",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    inviteUserToApp: async (userId, appId, email) => {
      const options = createRequestOptions({ userId, appId, email });

      const result = await fetch(
        Config.serverUrl + "/InviteUserToApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    invalidateApp: async (userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(Config.serverUrl + "/InvalidateApp", options);
      const response = await result.json();

      return get(response, "response");
    },
    cloneApp: async (userId, appId, appInfo) => {
      const options = createRequestOptions({ userId, appId, appInfo });

      const result = await fetch(Config.serverUrl + "/CloneApp", options);
      const response = await result.json();

      return get(response, "response");
    },
    getCustomApps: async (userId) => {
      const options = createRequestOptions({ userId });
      const result = await fetch(
        Config.mobileServerUrl + "/GetUserApps",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getCSATRequired: async (userId) => {
      const options = createRequestOptions({ userId });
      const result = await fetch(
        Config.serverUrl + "/GetCSATRequired",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addProgram: async (appId, userId, program) => {
      const options = createRequestOptions({ appId, userId, program });
      const result = await fetch(Config.serverUrl + "/AddProgram", options);
      const response = await result.json();

      return get(response, "response");
    },
    updateProgram: async (appId, userId, program) => {
      const options = createRequestOptions({ appId, userId, program });
      const result = await fetch(Config.serverUrl + "/UpdateProgram", options);
      const response = await result.json();

      return get(response, "response");
    },
    deleteProgram: async (appId, userId, programId) => {
      const options = createRequestOptions({ appId, userId, programId });
      const result = await fetch(Config.serverUrl + "/DeleteProgram", options);
      const response = await result.json();

      return get(response, "response");
    },
    addAppFavorite: async (appId, userId, instructionId) => {
      const options = createRequestOptions({ appId, userId, instructionId });
      const result = await fetch(Config.serverUrl + "/AddAppFavorite", options);
      const response = await result.json();

      return get(response, "response");
    },
    deleteAppFavorite: async (appId, userId, instructionId) => {
      const options = createRequestOptions({ appId, userId, instructionId });
      const result = await fetch(
        Config.serverUrl + "/DeleteAppFavorite",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getAppFavorites: async (appId, userId) => {
      const options = createRequestOptions({ appId, userId });
      const result = await fetch(
        Config.serverUrl + "/GetAppFavorites",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    saveNewLibraryInstruction: async (appId, userId, category) => {
      const options = createRequestOptions({ appId, userId, category });
      const result = await fetch(
        Config.mobileServerUrl + "/AddCategoryToAppTemplate",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    updateLibraryInstruction: async (appId, userId, category) => {
      const options = createRequestOptions({ appId, userId, category });
      const result = await fetch(
        Config.mobileServerUrl + "/UpdateCategoryInAppTemplate",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/apps.js